import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Link, useTranslation, useI18next } from 'gatsby-plugin-react-i18next'

import SocialLinks from 'components/SocialLinks'

import {
  rootStyle,
  titleStyle,
  textStyle,
  socialStyle,
  linksStyle,
  linksCaptionStyle
} from './Footer.styles'

function Footer() {
  const { languages, originalPath } = useI18next()
  const { t } = useTranslation()

  return (
    <Box sx={rootStyle}>
      <Typography variant="h6" component="h2" sx={titleStyle}>
        {t('footer.about')}
      </Typography>
      <Box sx={textStyle}>
        <Typography variant="body1" color="textSecondary" component="div">
          <p>{t('footer.intro1')}</p>
          <p>{t('footer.intro2')}</p>
        </Typography>
      </Box>
      <Box sx={socialStyle}>
        <Typography variant="overline" color="textSecondary" sx={linksCaptionStyle} component="div">
          {t('footer.followMe')}
        </Typography>
        <SocialLinks />
      </Box>
      <Box sx={linksStyle}>
        <Typography variant="overline">
          <Link to="/contact-us" title={t('footer.contact')}>
            {t('footer.contact')}
          </Link>
          <Link to="/privacy" title={t('footer.privacyPolicy')}>
            {t('footer.privacyPolicy')}
          </Link>
        </Typography>
      </Box>
      <Box sx={linksStyle}>
        <Typography variant="overline" color="textSecondary" sx={linksCaptionStyle} component="div">
          {t('footer.availableLangs')}
        </Typography>
        <Typography variant="overline" component="div">
          {languages.map(lang => (
            <Link key={lang} to={originalPath} language={lang}>
              {t(`languages.${lang}`)}
            </Link>
          ))}
        </Typography>
      </Box>
    </Box>
  )
}

export default Footer
